<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M40 6.66669C21.5905 6.66669 6.66669 21.5905 6.66669 40C6.66669 58.4095 21.5905 73.3334 40 73.3334C58.4095 73.3334 73.3334 58.4095 73.3334 40C73.3334 21.5905 58.4095 6.66669 40 6.66669ZM51.9349 33.2498C52.8092 32.1812 52.6517 30.6061 51.5831 29.7318C50.5145 28.8575 48.9394 29.015 48.0651 30.0836L34.8144 46.2789L30.1011 41.5656C29.1248 40.5893 27.5419 40.5893 26.5656 41.5656C25.5893 42.5419 25.5893 44.1248 26.5656 45.1011L33.2323 51.7678C33.7317 52.2672 34.4191 52.5321 35.1246 52.4969C35.83 52.4617 36.4876 52.1298 36.9349 51.5831L51.9349 33.2498Z"
            fill="#56B683"
        />
    </svg>
</template>
